import client from "../../helpers/api";
import {
  IUserList,
  IUser,
  IUpdateUser,
  IExercise,
  IWorkout,
  IUpdateUserIntro
} from "./types";

export function getUsers(params: any): Promise<IUserList[]> {
  return client.get(`/v2/users`, params);
}

export function getUser({
  userId
}: {
  userId: string;
}): Promise<IUser | undefined> {
  return client.get(`/v2/users/${userId}`, {});
}

export function updateUser({
  userId,
  data
}: {
  userId: string;
  data: IUpdateUser;
}): Promise<IUser | undefined> {
  return client.put(`/v2/users/${userId}`, data);
}

export function updateUserIntro({
  userId,
  data
}: {
  userId: string;
  data: IUpdateUserIntro;
}): Promise<string> {
  return client.put(`/v2/users/${userId}/intro`, data);
}

export function updateExercise({
  userId,
  workoutId,
  exerciseId,
  data
}: {
  userId: string;
  workoutId: string;
  exerciseId: string;
  data: Partial<IExercise>;
}): Promise<IExercise | undefined> {
  return client.put(
    `/v2/users/${userId}/workouts/${workoutId}/exercises/${exerciseId}`,
    data
  );
}

export function updateWorkout({
  userId,
  workoutId,
  data
}: {
  userId: string;
  workoutId: string;
  data: Partial<IWorkout>;
}): Promise<IWorkout | undefined> {
  return client.put(`/v2/users/${userId}/workouts/${workoutId}`, data);
}

export function deleteWorkout({
  userId,
  workoutId
}: {
  userId: string;
  workoutId: string;
}): Promise<string> {
  return client.del(`/v2/users/${userId}/workouts/${workoutId}`);
}

export function createWorkout({
  userId,
  data
}: {
  userId: string;
  data: IWorkout;
}): Promise<IWorkout | undefined> {
  return client.post(`/v2/users/${userId}/workouts`, data);
}
